import {
  Alert,
  Backdrop,
  Box,
  CircularProgress,
  Container,
  Grid,
  Icon,
  Snackbar,
  Typography,
  Button,
  Divider,
  // TextField,
  Stepper,
  Step,
  StepLabel,
  Stack,
  // CardContent,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  TextField,
  MenuItem,
  FormControl,
  InputAdornment,
  IconButton,
  AppBar,
  Toolbar,
  Paper,
} from "@mui/material";
import { useEffect, useState } from "react";
import CheckoutFooter from "../../components/footer";
import AppConfig from "../../../appConfig";
import axios from "../../../axios";
import usePageTitle from "../../pageTitle";
import { useNavigate, useParams } from "react-router-dom";

function WebStoreHome() {
  const [pageTitle, setPageTitle] = useState("WebStore");
  usePageTitle(pageTitle);
  const navigate = useNavigate();
  const { ref } = useParams();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [webstore, setWebStore] = useState({});
  const [campaigns, setCampaigns] = useState([]);

  useEffect(() => {
    if (ref === null) {
      navigate("/error");
      return;
    }

    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`webstore/${ref}`)
        .then((result) => {
          console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setPageTitle(`Laddar Africa | ${result.data.data.webstore.title}`);
            setWebStore(result.data.data.webstore);
            setCampaigns(result.data.data.campaigns);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);

            navigate("/error");
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine
                ? ""
                : "Make sure you have an active internet connection"
            }`,
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  return (
    <>
      <Box mb={5}>
        <AppBar>
          <Toolbar>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ mr: 2 }}
            >
              <img
                // src="https://placehold.co/600x400.png"
                src={`${AppConfig.api_media_url}${webstore.logo}`}
                alt="img"
                width="24px"
              />
            </IconButton>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              {webstore.title}
            </Typography>
            {/* <div>
                <IconButton size="large" color="inherit">
                  <Icon>shopping_cart</Icon>
                </IconButton>
              </div> */}
          </Toolbar>
        </AppBar>
      </Box>
      <Box mb={15}>
        <Box sx={{ width: "100%", maxWidth: "800px", margin: "0px auto" }}>
          <Box mt={10}>
            <Paper elevation={0}>
              <Box align="center" px={2}>
                <img
                  // src="https://placehold.co/600x400.png"
                  src={`${AppConfig.api_media_url}${webstore.logo}`}
                  alt="img"
                  width="50%"
                />
                <Box mt={1}>
                  <Typography variant="h6" fontSize={14}>
                    Welcome to
                  </Typography>
                </Box>
                <Box mt={1}>
                  <Typography variant="h4" fontWeight={300}>
                    {webstore.title}
                  </Typography>
                </Box>
              </Box>
              <Box mt={5} mb={5}>
                <Grid container spacing={3}>
                  <Grid item xs={6} md={6} lg={6}>
                    <Box
                      align="center"
                      onClick={() => {
                        window.location = `mailto:${webstore.email_address}`;
                      }}
                    >
                      <Icon color="primary">email</Icon>
                      <Typography variant="h6" fontSize={10}>
                        {webstore.email_address}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6} md={6} lg={6}>
                    <Box
                      align="center"
                      onClick={() => {
                        window.location = `tel:${webstore.phone_number}`;
                      }}
                    >
                      <Icon color="primary">phone</Icon>
                      <Typography variant="h6" fontSize={10}>
                        {webstore.phone_number}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
              {/* <Box mt={5} mb={0}>
                &nbsp;
              </Box> */}
            </Paper>
          </Box>
          <Divider />
          <Box mt={5}>
            <Box
              mt={3}
              sx={{
                textAlign: { xs: "center" },
              }}
            >
              <Button
                onClick={() => navigate(`/ws/products/${webstore.reference}`)}
              >
                <Typography variant="h6" fontWeight={800}>
                  SHOP NOW
                </Typography>
              </Button>
            </Box>
            <Box mt={0} px={3}>
              <List>
                {campaigns.map((campaign) => (
                  <Box my={4}>
                    <Paper elevation={3}>
                      <Box p={2}>
                        <ListItem
                          key={
                            <Typography color="primary">
                              {campaign.reference}
                            </Typography>
                          }
                          sx={{ py: 1, px: 0 }}
                          onClick={() =>
                            navigate(`/ws/category/${campaign.reference}`)
                          }
                        >
                          <ListItemText
                            sx={{ mr: 2 }}
                            primary={
                              <Typography fontSize={18} fontWeight={700}>
                                {campaign.title}
                              </Typography>
                            }
                            secondary={
                              <Box mt={1}>
                                <Typography fontSize={12}>
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: campaign.description,
                                    }}
                                  />
                                </Typography>
                              </Box>
                            }
                          />
                          <ListItemIcon>
                            <Icon color="primary">keyboard_arrow_right</Icon>
                          </ListItemIcon>
                        </ListItem>
                      </Box>
                    </Paper>
                  </Box>
                ))}
              </List>
            </Box>
          </Box>
        </Box>
      </Box>
      <CheckoutFooter />
    </>
  );
}

export default WebStoreHome;
